import React from "react";
import TimelineItem from "./TimelineItem";
import { Briefcase } from "lucide-react";

const Experience: React.FC = () => {
  const experiences = [
    {
      title: "Product Lead & Mobile Developer",
      organization: "Masraf",
      period: "September 2023 - Present",
      location: "Rabat, Morocco",
      description:
        "Leading product vision and development of a secure mobile banking application built with React Native, while mentoring a team of developers.",
      highlights: [
        "Led and mentored a team of 4 developers, fostering collaboration and ensuring adherence to best practices",
        "Designed and implemented core banking functionalities including secure authentication, real-time transactions, and KYC workflows",
        "Created a reusable component library with React, Storybook, and TailwindCSS to maintain UI consistency",
        "Set up Dockerized environments and CI/CD pipelines to streamline mobile build, testing, and deployment processes",
      ],
    },
    {
      title: "Full-stack Developer",
      organization: "Bewizyu",
      period: "June 2022 - September 2023",
      location: "Rabat, Morocco",
      description:
        "Managed the full development lifecycle for key internal projects while maintaining and enhancing client applications.",
      highlights: [
        "Built b-staffing (Next.js/Laravel staff management tool) and a GitLab-integrated code review tool (React/Laravel/OpenAI API)",
        "Optimized critical database queries affecting over 1 million records, achieving 65% improvement in response times",
        "Developed a custom multi-tenant CMS solution for Poujoulat using Strapi and Next.js",
        "Mentored new developers and maintained Docker environments and GitLab CI/CD pipelines across various projects",
      ],
    },
    {
      title: "Frontend Developer",
      organization: "SQLI Maroc",
      period: "February 2022 - July 2022",
      location: "Rabat, Morocco",
      description:
        "Led the frontend redesign of a major brand's e-commerce platform using Vue.js.",
      highlights: [
        "Implemented Storybook to standardize UI component development",
        "Improved front-end performance, resulting in a 30% improvement in load times",
        "Created documentation that enhanced team onboarding efficiency",
      ],
    },
    {
      title: "Full-stack Developer",
      organization: "Joodek",
      period: "July 2021 - February 2022",
      location: "Rabat, Morocco",
      description:
        "Led development of multiple web applications focusing on Arabic-language tools and marketing management.",
      highlights: [
        "Developed Adawat AI, an Arabic-focused tools platform using NuxtJS and Laravel",
        "Built a coupon code and marketing management platform with Laravel",
        "Managed frontend, backend, and DevOps processes for multiple projects",
      ],
      isLast: true,
    },
  ];

  return (
    <section id="experience" className="py-20 bg-gray-50">
      <div className="container-custom">
        <div className="flex items-center mb-8">
          <Briefcase size={28} className="text-portfolio-blue mr-3" />
          <h2 className="section-title mb-0">Professional Experience</h2>
        </div>

        <div className="mt-10">
          {experiences.map((experience, index) => (
            <TimelineItem
              key={index}
              title={experience.title}
              organization={experience.organization}
              period={experience.period}
              location={experience.location}
              description={experience.description}
              highlights={experience.highlights}
              isLast={experience.isLast || index === experiences.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
